import React from 'react';
import { Stars } from 'react-bootstrap-icons';
import './ActionChip.css';

interface ActionChipProps {
  label: string;
  onClick: () => void;
}

const ActionChip: React.FC<ActionChipProps> = ({ label, onClick }) => {
  return (
    <button type="button" className="action-chip" onClick={onClick}>
      <Stars size={12} className="action-chip-icon" />
      <span className="action-chip-label">{label}</span>
    </button>
  );
};

export default ActionChip;
